import { Inject, Injectable, OnInit, afterNextRender } from '@angular/core';
import { IntrackSdk, IWebEngageSdk } from '@core/models/DTOs/webengage-sdk';
import { Interface } from 'readline';

declare var webengage: IWebEngageSdk;
declare var Intk: any;
export enum labels {}

@Injectable({
 providedIn: 'root',
})
export class WebengageService {
 labels: any = {
  45: 'iho+',
  36: 'فاصله کوتاه با مترو',
  44: 'اتاق ساعتی',
  33: 'هتل نوساز',
  38: 'هتل بازسازی شده',
 };

 accommodationType: any = {
  1: 'هتل',
  2: 'هتل آپارتمان',
  6: 'خانه، ویلا، سوییت',
  3: 'بومگردی',
  4: 'اقامتگاه',
  5: 'مهمان پذیر',
 };
 constructor() {
  afterNextRender(() => {
   try {
    //  if (![undefined, null, ''].includes((window as any).webengage))
    //   webengage.options('proxyURL', 'webengage.iho.co');
   } catch {}
  });
 }
 init(apiKey: string): void {}

 track(eventName: string, properties?: Record<string, any>): void {
  if (eventName.toLocaleLowerCase() == 'select filter') {
   try {
   } catch {}
  }
  try {
   if (webengage) webengage.track(eventName, properties);
  } catch {
   return;
  }
 }
 trackIntrack(eventName: string, properties?: Record<string, any>) {
  try {
    Intk('sendEvent', {
          eventName,
          eventData: properties
    });

  } catch (error) {
   console.log('error intrack', error);
  }

  //  Intk('Test Milad', { testIho: 'Milad' })
  //  Intk('Milad', {
  //     eventName: 'Milad-custom-event',
  //     eventData: {
  //        count: 1000,
  //        label: 'two',
  //        accepted: false,
  //        date: '1970-01-01',
  //        myDetails: {
  //           one: 1,
  //           myList: ['firstValue', 'secondValue'],
  //        },
  //     },
  //  });
 }

 intrackLogin(user: any) {
  
  const userDetails = {
    "firstName": user.FirstName,
    "lastName": user.LastName,
    "email": user.Email,
    "phone": "+98" + user.Mobile,
    "country": "",
    "state": "",
    "city":  "",
    "gender": "other",
    "birthday": "",
    "company":  "",
    "hashedPhone": "",
    "hashedEmail": "",
    "smsOptIn": false,
    "emailOptIn": false,
    "pushOptIn": false,
    "webPushOptIn": false,
    "userId": user.sub,
    "attributes": {
      "userType": user.UserType,
      "registerType": user.RegisterType,
      "role": user.role
    }
  }
  
  try {
   if (Intk) Intk('login', userDetails);
   
  } catch (error) {
  }
 }

 screen(screenName: string, properties?: Record<string, any> | undefined): void {}

 onReady(callback: () => void): void {}

 userIdentify(userId: string, attributes?: Record<string, any> | undefined): void {}

 userLogin(userId: string, attributes?: Record<string, any> | undefined): void {
  try {
   if (webengage) webengage.user.login(userId, attributes);
  } catch {
   return;
  }
 }

 userLogout(): void {
  try {
   if (webengage) webengage.user.logout();
  } catch {
   return;
  }
}

 inTrackUserLogout(): void {
  try {
   if (Intk) Intk('logout') ;
  } catch {
   return;
  }
 }

 userSetAttribute(name: string, value: any): void {
  try {
   if (webengage) webengage.user.setAttribute(name, value);
  } catch {
   return;
  }
 }

 showNotification(message: string): void {}

 hideNotification(): void {}

 showSurvey(surveyId: string): void {}

 hideSurvey(): void {}

 showFeedback(): void {}

 hideFeedback(): void {}

 opennNtificationInbox(): void {}

 closeNotificationInbox(): void {}

 // loadWebEngageScript() {
 //   script.src = 'apps/ihowebsite/src/app/webengage-sdk.js';
 //   script.id = '_webengage_script_tag';
 //   script.type = 'text/javascript';
 //   document.head.appendChild(script);
 // }

 // createAttributes(type: Interface): Record<string, any> {}
}
